import React from 'react';

interface StructuredDataProps {
  type: 'Person' | 'Article' | 'Organization';
  data?: any;
}

const StructuredData: React.FC<StructuredDataProps> = ({ type, data = {} }) => {
  const generatePersonData = () => {
    return {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Udobong Ntia',
      jobTitle: 'Oil & Gas Executive',
      description: 'A purpose-driven leader dedicated to empowering future generations and driving sustainable economic growth.',
      image: 'https://udobongntia.com/static/media/heroImage.png',
      url: 'https://udobongntia.com',
      sameAs: [
        'https://www.linkedin.com/in/udobong-ntia-b171871',
        // Add other social profiles if available
      ],
      alumniOf: {
        '@type': 'CollegeOrUniversity',
        name: 'University of Houston',
      },
      worksFor: {
        '@type': 'Organization',
        name: 'ExxonMobil (Former)',
      },
      ...data,
    };
  };

  const generateArticleData = () => {
    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: data.headline || 'Udobong Ntia: Oil & Gas Executive',
      image: data.image || 'https://udobongntia.com/static/media/heroImage.png',
      datePublished: data.datePublished || new Date().toISOString(),
      dateModified: data.dateModified || new Date().toISOString(),
      author: {
        '@type': 'Person',
        name: 'Udobong Ntia',
      },
      publisher: {
        '@type': 'Person',
        name: 'Udobong Ntia',
        logo: {
          '@type': 'ImageObject',
          url: 'https://udobongntia.com/logo192.png',
        },
      },
      ...data,
    };
  };

  const generateOrganizationData = () => {
    return {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Udobong Ntia',
      url: 'https://udobongntia.com',
      logo: 'https://udobongntia.com/logo192.png',
      description: 'Udobong Ntia - Oil & Gas Executive, Energy Leader, and Mentor with over 20 years of industry experience.',
      ...data,
    };
  };

  const getStructuredData = () => {
    switch (type) {
      case 'Person':
        return generatePersonData();
      case 'Article':
        return generateArticleData();
      case 'Organization':
        return generateOrganizationData();
      default:
        return generatePersonData();
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(getStructuredData()) }}
    />
  );
};

export default StructuredData;
